import React from "react";
import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import "../css/CheckInAcknowledgementDialog.css";
import letsDoItIcon from "../../assets/images/lets-do-it-icon.svg";
import { getWorkspaceSlotTime } from "utils/utils";

interface CheckInAcknowledgementDialogProps {
  open: boolean;
  onClose: () => void;
  reservationData: any;
  slotData: any;
  onClickCheckIn?: () => void;
  isLoading?: boolean;
}

const CheckInAcknowledgementDialog: React.FC<
  CheckInAcknowledgementDialogProps
> = ({
  open,
  onClose,
  reservationData,
  slotData,
  onClickCheckIn,
  isLoading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "check-in-acknowledgement-dialog-container",
      }}
      BackdropProps={{
        className: "check-in-acknowledgement-dialog-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="check-in-acknowledgement-dialog-header">
          Acknowledgement
        </div>
        <div className="check-in-acknowledgement-dialog-header-title">
          ARE YOU SURE, DO YOU WANT TO <span>CHECK IN</span> THIS MEMBER
        </div>
        <div className="check-in-acknowledgement-dialog-containt-container">
          <div className="username">{reservationData?.user_name}</div>
          <span>{`${getWorkspaceSlotTime(
            slotData?.start_time
          )} - ${getWorkspaceSlotTime(slotData?.end_time)}`}</span>
          <span className="booking_id">
            Booking ID :{" "}
            <span className="booking_id" style={{ color: "white" }}>
              {reservationData?.booking_id}
            </span>
          </span>
        </div>
        <div
          className="check-in-acknowledgement-dialog-do-it-button"
          onClick={onClickCheckIn}
        >
          {isLoading ? (
            <CircularProgress size={30} color="inherit" />
          ) : (
            <>
              <div>Check In</div>
              <img src={letsDoItIcon} alt="lets-do-it-logo" className="image" />
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CheckInAcknowledgementDialog;
